import { TChannel } from 'src/interfaces/conversation';
import { SESSION_WINDOW } from '../constants';
import { TChannelBlockReason, TResolvedChannel } from '../types';

/**
 * A resolved channel where nothing can be sent, for the given reason.
 */
export const blockedChannel = (
    channel: TChannel,
    reason: TChannelBlockReason
): TResolvedChannel => ({
    channel,
    provider: null,
    senderPhone: null,
    sessionWindow: SESSION_WINDOW.UNKNOWN,
    canSendFreeForm: false,
    canSendTemplate: false,
    freeFormBlockReason: reason,
    templateBlockReason: reason,
});
